<template>
  <div class="md:flex">
    <div class="flex-col w-full space-y-4">
      <div class="h-28 bg-slate-200 rounded col-span-2"></div>
      <div class="grid grid-cols-4 gap-4">
        <div class="h-3 bg-slate-200 rounded col-start-1 col-end-2"></div>
        <div class="h-3 bg-slate-200 rounded col-start-4 col-end-5"></div>
      </div>
      <div class="h-4 bg-slate-200 rounded col-span-1"></div>
      <div class="grid grid-cols-3 gap-4">
        <div class="h-2 bg-slate-200 rounded col-span-1"></div>
      </div>
    </div>
  </div>
</template>
